import { useCallback, useEffect, useState } from 'react'

export type CopyStatus = 'inactive' | 'copied' | 'failed'

export const useClipboard = (notifyTimeout = 2000) => {
    const [copyStatus, setCopyStatus] = useState<CopyStatus>('inactive')

    useEffect(() => {
        if (copyStatus === 'inactive') {
            return
        }
        const timeoutId = setTimeout(() => setCopyStatus('inactive'), notifyTimeout)

        return () => clearTimeout(timeoutId)
    }, [copyStatus, notifyTimeout])

    const onSetCopyStatus = useCallback((textToCopy: string | undefined) => {
        if (!textToCopy) {
            setCopyStatus('failed')

            return
        }
        navigator.clipboard.writeText(textToCopy).then(
            () => setCopyStatus('copied'),
            () => setCopyStatus('failed')
        )
    }, [])

    return { copyStatus, onSetCopyStatus }
}
